function FolderConfigStatsBar({
  documentedPatternCount,
  awaitingDocumentationCount,
  totalConcreteDirectories,
  documentedConcreteDirectories,
  coveragePercent,
}: {
  documentedPatternCount: number;
  awaitingDocumentationCount: number;
  totalConcreteDirectories: number;
  documentedConcreteDirectories: number;
  coveragePercent: number;
}) {
  return (
    <div className="grid shrink-0 grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <div className="rounded-lg border border-slate-200 bg-white px-4 py-2.5">
        <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-blue-100">
          Documented Patterns
        </p>
        <p className="text-lg font-semibold text-emerald-600">
          {documentedPatternCount}
        </p>
        <p className="text-xs text-grey-200">
          Unique folder patterns with descriptions
        </p>
      </div>
      <div className="rounded-lg border border-slate-200 bg-white px-4 py-2.5">
        <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-blue-100">
          Awaiting Documentation
        </p>
        <p className="text-lg font-semibold text-amber-600">
          {awaitingDocumentationCount}
        </p>
        <p className="text-xs text-grey-200">
          Patterns seen on the vessel but not yet documented
        </p>
      </div>
      <div className="rounded-lg border border-slate-200 bg-white px-4 py-2.5">
        <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-blue-100">
          Observed Directories
        </p>
        <p className="text-lg font-semibold text-blue-300">
          {totalConcreteDirectories.toLocaleString()}
        </p>
        <p className="text-xs text-grey-200">
          Total concrete folders across all cruises
        </p>
      </div>
      <div className="rounded-lg border border-slate-200 bg-white px-4 py-2.5">
        <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-blue-100">
          Coverage
        </p>
        <p className="text-lg font-semibold text-blue-300">
          {coveragePercent}%
        </p>
        <p className="text-xs text-grey-200">
          {documentedConcreteDirectories.toLocaleString()} of{" "}
          {totalConcreteDirectories.toLocaleString()} directories covered
        </p>
      </div>
    </div>
  );
}

export default FolderConfigStatsBar;
